(() => {
  if (window.kdkCartUpsellInitialized) return;
  window.kdkCartUpsellInitialized = true;

  const selector = 'details[data-kdk-cart-upsell]';
  const storageKey = 'kdk.cartRecommendations.open.v1';
  const initialized = new WeakSet();
  let preference = null;

  try {
    const saved = sessionStorage.getItem(storageKey);
    if (saved === 'open' || saved === 'closed') preference = saved;
  } catch {}

  const initialize = (root) => {
    const elements = root.matches?.(selector)
      ? [root, ...root.querySelectorAll(selector)]
      : root.querySelectorAll(selector);

    elements.forEach((details) => {
      if (initialized.has(details)) return;
      initialized.add(details);
      if (preference !== null) details.open = preference === 'open';

      const summary = details.querySelector(':scope > summary');
      summary.setAttribute('aria-expanded', String(details.open));
      let userToggle = false;

      summary.addEventListener('click', () => {
        userToggle = true;
      });

      details.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(details.open));
        if (!userToggle) return;
        userToggle = false;
        preference = details.open ? 'open' : 'closed';

        try {
          sessionStorage.setItem(storageKey, preference);
        } catch {}

        document.querySelectorAll(selector).forEach((other) => {
          if (other !== details) other.open = details.open;
        });
      });
    });
  };

  const start = () => {
    initialize(document);
    new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) initialize(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
